var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUparrowicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1702",
    "data-name": "Group 1702",
    transform: "translate(-1097 -305)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_308",
    "data-name": "Ellipse 308",
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    transform: "translate(1097 305)",
    fill: "#004c75",
    opacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    id: "down-chevron",
    d: "M15.643,9.084,8.251,1.716.858,9.084,0,8.224,8.251,0,16.5,8.224Z",
    transform: "translate(1106.771 317.854)",
    fill: "#004c75"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUparrowicon);
export default __webpack_public_path__ + "static/media/Uparrowicon.0cea0fc5c11fd182d5e51f048a702e4b.svg";
export { ForwardRef as ReactComponent };